import { SVGProps } from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}
export const IconUserCircle = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 24 24"
        display="block"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M4 12a8 8 0 1 1 14.115 5.158L10 15a5 5 0 0 0-4.115 2.158A7.97 7.97 0 0 1 4 12m4-2a4 4 0 0 1 3.633-3.983l-.387 2.13a2 2 0 0 0-.604 3.321l-.387 2.132A4 4 0 0 1 8 10m4.986-3.877 2.614 5.623a4.002 4.002 0 0 0-2.613-5.623M12 20a7.96 7.96 0 0 1-4.618-1.467A3 3 0 0 1 10 17h4a3 3 0 0 1 2.618 1.533A7.96 7.96 0 0 1 12 20m10-8a9.98 9.98 0 0 1-3.563 7.653A9.96 9.96 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            d="M18.115 17.158A5 5 0 0 0 14 15h-4zM14 10a2 2 0 0 1-3.358 1.468l-.387 2.132a4 4 0 0 0 5.345-1.854l-2.613-5.623a4 4 0 0 0-1.354-.106l-.387 2.13A2 2 0 0 1 14 10"
        />
    </svg>
);
